module.exports = __webpack_public_path__ + "img/idcard_chip.5d31fbf1.svg";